<main>
    <app-banner></app-banner>
    <!-- <app-jobs></app-jobs> -->

    <app-about></app-about>
    <app-proyects></app-proyects>
    <!-- <app-more-proyects></app-more-proyects>
     -->
    
    
    
    
    
   
    <!-- <app-contact></app-contact> -->

    
</main>

